"use client";
import * as React from "react";
import { ArthaLogo } from "@/components/icons";
import Link from "next/link";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";

type InviteLandingNavbarProps = {
  onSignupClick?: () => void | Promise<void>;
};

export function InviteLandingNavbar({ onSignupClick }: InviteLandingNavbarProps) {
  const [hidden, setHidden] = React.useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    const previous = scrollY.getPrevious() ?? 0;
    if (latest > previous && latest > 2) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  });

  return (
    <motion.nav
      variants={{
        visible: { y: 0, opacity: 1 },
        hidden: { y: -150, opacity: 0 },
      }}
      animate={hidden ? "hidden" : "visible"}
      transition={{ duration: 0.35, ease: "easeInOut" }}
      className="fixed top-5 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-3rem)] max-w-7xl"
    >
      <div className="flex items-center justify-between rounded-[16px] border border-[#101828]/5 bg-white px-3 py-4 shadow-[0px_2px_16px_0px_rgba(0,0,0,0.1)] sm:px-5">
        <Link href="/" className="flex items-center px-[15px]">
          <ArthaLogo />
        </Link>

        <div className="flex items-center">
          <button
            type="button"
            onClick={() => {
              void onSignupClick?.();
            }}
            className="inline-flex h-11 items-center justify-center rounded-[10px] border-2 border-[#101828] bg-[#1051F3] px-5 text-sm sm:h-13 text-white shadow-[4px_4px_0px_0px_#101828] sm:shadow-[5px_5px_0px_0px_#101828] transition-all hover:translate-y-[-2px] hover:shadow-[7px_7px_0px_0px_#101828] active:translate-x-[3px] font-semibold sm:text-lg active:translate-y-[3px] active:shadow-none font-plus-jakarta-sans"
          >
            Signup
          </button>
        </div>
      </div>
    </motion.nav>
  );
}
